module.exports = __webpack_public_path__ + "img/shoot_00026.9e91d940.png";